import React from 'react';

const AboutSection = () => {
    return (
        <section className="about-section py-2" style={{backgroundColor:'#EEE4E6'}}>
            <div className="pattern-layer" style={{ backgroundImage: 'url(/iimages/shape/shape-1.png)' }}></div>
            <div className="auto-container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                        <div className="content_block_one">
                            <div className="content-box mr_60">
                                <div className="sec-title mb_30">
                                    <span className="sub-title">Welcome to S9 Travels</span>
                                    <h2>Let S9 Travels Make Your Next Adventure Unforgettable</h2>
                                </div>
                                <div className="text-box mb_35">
                                    <p className='text-dark'>S9 Travels is committed to providing unparalleled travel experiences. Whether you’re planning a relaxing getaway or an adventurous journey, we are here to ensure your trip is smooth and memorable.</p>
                                </div>
                                <div className="inner-box">
                                    <div className="single-item">
                                        <div className="icon-box"><i className="icon-13"></i></div>
                                        <h3 className='darkcolorrr'>Custom Travel Packages</h3>
                                        <p className='text-dark'>We specialize in tailored itineraries that match your specific interests and preferences.</p>
                                    </div>
                                    <div className="single-item">
                                        <div className="icon-box"><i className="icon-14"></i></div>
                                        <h3 className='darkcolorrr'>Expert Travel Consultants</h3>
                                        <p className='text-dark'>Our team of travel experts offers personalized advice and insider tips to ensure you get the best out of every destination.</p>
                                    </div>
                                    <div className="single-item">
                                        <div className="icon-box"><i className="icon-15"></i></div>
                                        <h3 className='darkcolorrr'>24/7 Support</h3>
                                        <p className='text-dark'>We offer round-the-clock customer support to assist you whenever you need help during your journey.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                        <div className="image_block_one">
                            <div className="image-box">
                                <figure className="image image-1"><img src="/images/toyota.webp" alt="about-1" /></figure>
                                <figure className="image image-2"><img src="/images/innova-list3.webp" alt="about-2" /></figure>
                                {/* <figure className="image image-3"><img src="/images/resource/about-3.jpg" alt="about-3" /></figure> */}
                                <figure className="image image-3"><img src="/images/aura-list4.webp" alt="about-3" /></figure>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutSection;
